export const protocols = [{value: "http", label: "Http"}, {value: "https", label: "Https"}]